import { ChangeDetectorRef, Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription, take } from 'rxjs';
import { PropertyService } from '../../services/PropertyService';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Result } from '../../models/result';
import { BPSpreadData } from '../../models/auction';

@Component({ standalone: false,
  selector: 'edit-reserve-credit-dialog',
  templateUrl: 'edit-reserve-credit-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['edit-reserve-credit-dialog.component.scss']
})
export class EditReserveCreditDialogComponent {
  public title: string= "CHANGE RESERVE";
  public confirmButtonText = "Confirm";
  public cancelButtonText = "Cancel";

  public bpSpreadData!: BPSpreadData;
  public auctionUpdatedSubscription?:Subscription;
  public reserveCreditForm:FormGroup;

  public busy:boolean=false;
  private reservePriceOptionChangedSubscription?:Subscription;
  
  constructor(@Inject(MAT_DIALOG_DATA) private data: any, private dialogRef: MatDialogRef<EditReserveCreditDialogComponent>, private propertyService:PropertyService, public snackBar: MatSnackBar, private cd:ChangeDetectorRef) {
    if(data){
      this.bpSpreadData=data.bpSpreadData;
    }
    this.reserveCreditForm = new FormGroup({
      reservePriceOption: new FormControl<number>(1, Validators.required),
      reservePrice: new FormControl<number>(this.bpSpreadData.minimumReserve),
    });
  }

  ngOnInit(){
    this.reservePriceOptionChangedSubscription =this.reserveCreditForm.get('reservePriceOption')!.valueChanges.subscribe(value=>{
      if(value === 3){
        this.reserveCreditForm.get('reservePrice')!.setValidators(Validators.compose([Validators.required, Validators.min(this.bpSpreadData.minimumReserve), Validators.max(this.bpSpreadData.clientReserve)]));
      }
      else{
        this.reserveCreditForm.get('reservePrice')!.setValidators(null);
      }
      this.reserveCreditForm.updateValueAndValidity();
      this.cd.detectChanges();
    });
  }

  ngOnDestroy(){
    if(this.auctionUpdatedSubscription)this.auctionUpdatedSubscription.unsubscribe();
    if(this.reservePriceOptionChangedSubscription) this.reservePriceOptionChangedSubscription.unsubscribe();
  }

  onConfirmClick(): void {
    this.busy=true;
    let option = this.reserveCreditForm.get('reservePriceOption')!.value;
    let reserveCredit = undefined;
    if(option === 1){
      reserveCredit = this.bpSpreadData.clientReserve - this.bpSpreadData.minimumReserve;
    }
    else if(option === 2){
      reserveCredit = this.bpSpreadData.clientReserve - this.bpSpreadData.reserveMetNextBid;
    }
    else if(option === 3){
      reserveCredit = this.reserveCreditForm.get('reservePrice')!.value? this.bpSpreadData.clientReserve - this.reserveCreditForm.get('reservePrice')!.value : undefined
    }
    if(reserveCredit) this.propertyService.reserveCredit(this.bpSpreadData.auction.id, this.bpSpreadData.auction!.scheduleSeqNo!, reserveCredit).pipe(take(1)).subscribe(r=>this.processReserveCreditResult(r));
  }
  onCancelClick(): void {
    this.dialogRef.close(false);
  }

  get canSubmit(){
    console.log("canSubmit: ", this.reserveCreditForm.get('reservePrice')!.valid);
    return this.reserveCreditForm.valid && !this.busy;
  }

  get canCancel(){
    return !this.busy;
  }

  private processReserveCreditResult(result:Result){
    this.busy=false;
    if(result.success){
      this.snackBar.open("Reserve credit successfully applied", '×', { panelClass: ['primary-snackbar'], verticalPosition: 'top', duration: 3000 });
    }
    else{
      this.snackBar.open("Reserve not applied: " + result.message, '×', { panelClass: ['warn-snackbar'], verticalPosition: 'top' });
    }
    this.dialogRef.close(false);
  }

}